import { observer } from 'mobx-react-lite'
import { Typography } from 'shared/ui'
import { DayjsFormats } from 'shared/lib'
import { uiStore } from 'shared/store/uiStore'
import { MessageCard } from 'widgets/MessageCard'
import { type CreditUsageMessageModalStore } from '../store/creditUsageMessageModalStore'
import styles from './styles.module.scss'

type ICreditUsageMessageModalContentProps = {
  store: CreditUsageMessageModalStore
}

export const CreditUsageMessageModalContent = observer(
  ({ store }: ICreditUsageMessageModalContentProps) => {
    const { message, creditUsage } = store

    return (
      <div className={styles.wrapper}>
        <Typography className={styles.date} variant={'body-sm-regular'} ariaLabel={'MessageDate'}>
          {uiStore.dayjs(creditUsage.processed_at).format(DayjsFormats.full5)}
        </Typography>
        <MessageCard
          message={message}
          isLast={true}
          hideTeam={false}
          conversationMessagesStore={null}
          callContentStore={undefined}
        />
      </div>
    )
  }
)
